module.exports = __webpack_public_path__ + "img/retired-2008-xibaipo.dc635109.jpg";